{
  "name": "csc-cashback-webportal",
  "version": "0.0.30",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "start:testSaaa": "ng serve --configuration testSaaa",
    "start:testBrennero": "ng serve --configuration testBrennero",
    "build": "npm install && ng build --configuration production --source-map --base-href /csc-cashback/",
    "build:testSaaa": "npm install && ng build --configuration testSaaa --source-map",
    "build:prodSaaa": "npm install && ng build --configuration prodSaaa --source-map",
    "build:prodBrennero": "npm install && ng build --configuration prodBrennero --source-map",
    "build-aws": "npm install && ng build --configuration production --source-map",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.8.2",
  "dependencies": {
    "@angular/animations": "21.1.5",
    "@angular/cdk": "21.1.5",
    "@angular/common": "21.1.5",
    "@angular/compiler": "21.1.5",
    "@angular/core": "21.1.5",
    "@angular/forms": "21.1.5",
    "@angular/material": "21.1.5",
    "@angular/platform-browser": "21.1.5",
    "@angular/router": "21.1.5",
    "@ngx-translate/core": "16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "@npt/sdk": "21.0.17",
    "dayjs": "1.11.20",
    "ngx-iban-validator": "1.2.4",
    "ngx-mask": "^21.0.1",
    "npm": "^11.12.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular/build": "21.1.5",
    "@angular/cli": "21.1.5",
    "@angular/compiler-cli": "21.1.5",
    "angular-eslint": "^21.3.1",
    "eslint": "^10.3.0",
    "eslint-plugin-simple-import-sort": "^13.0.0",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
